import useDataFetcher from '~/components/useDataFetcher';
import type { HookEndpointResponse } from '~/server_shared/openapi/data-contracts';

export const getHookEndpointsUrl = (organizationId: number) =>
  `/sysconfig/api/v1/organizations/${organizationId}/hook_endpoints`;

const useHookEndpoints = (organizationId: number) => {
  return useDataFetcher<HookEndpointResponse[]>(getHookEndpointsUrl(organizationId));
};

export default useHookEndpoints;
